import React from "react";
import styled from "styled-components";

const FormField = ({ label, badge, hint, infoButton, children }) => (
  <FieldGroup>
    {(label || badge) && (
      <LabelRow>
        {infoButton ? (
          <LeftSide>
            {label && <Label>{label}</Label>}
            {infoButton}
          </LeftSide>
        ) : (
          label && <Label>{label}</Label>
        )}
        {badge}
      </LabelRow>
    )}
    {children}
    {hint && <FieldHint>{hint}</FieldHint>}
  </FieldGroup>
);

export default FormField;

const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const LabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const FieldHint = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  opacity: 0.8;
  margin: 0;
`;
